/* -------------------------------------------------- */
/* -------------------------------------------------- */
/* ----- VARIABLES (INITIALIZATION) ----------------- */
/* -------------------------------------------------- */
/* -------------------------------------------------- */



/* -------------------------------------------------- */
/* -------------------------------------------------- */
/* ----- IMPORTS ------------------------------------ */
/* -------------------------------------------------- */
/* -------------------------------------------------- */

import.meta.glob([
	'../images/**',
	'../fonts/**',
	'../videos/**',
]);

import './bootstrap';
import { tone_card, countries } from './variables';

import $ from "jquery";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';
import Splide from '@splidejs/splide';
import { _ } from 'lodash';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'

Alpine.plugin( focus );
gsap.registerPlugin( ScrollSmoother, ScrollTrigger, ScrambleTextPlugin, ScrollToPlugin, SplitText );

/* -------------------------------------------------- */
/* -------------------------------------------------- */
/* ----- VARIABLES ---------------------------------- */
/* -------------------------------------------------- */
/* -------------------------------------------------- */

let recordedResult = undefined;

window.Alpine = Alpine;
window.$ = $;

/* -------------------------------------------------- */
/* -------------------------------------------------- */
/* ----- GENERAL ------------------------------------ */
/* -------------------------------------------------- */
/* -------------------------------------------------- */

const hasTouchSupport = () => {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

const isMobileSize = () => {
	const minWidth = 768; // Minimum width for desktop devices
	// console.log( window.innerWidth, screen.width, minWidth );
  	return window.innerWidth < minWidth || screen.width < minWidth;
};

( function( selector )
{
	'use strict'

    var scope = $( selector );
    if( !scope.length ) return;

    var colors = [ [ '#FAD6C0', '#E8C3A8', '#DCB58C', '#DCA475' ], [ '#DF9D7B', '#C6926A', '#9F664B', '#834432' ], [ '#6D3C2E', '#723A29', '#5C2E1F', '#773C2A' ] ];

    for (var i = 0; i < scope.length; i++)
    {
	    scope.eq( i ).append( "<div class='logo-palette'></div>" );

	    var grid = new Array();
	    for (var x = 0; x < 3; x++)
	    {
	    	grid.push( new Array() );
		    for (var y = 0; y < 4; y++)
		    {
		    	grid[ x ].push( new Array() );
		    	grid[ x ][ y ] = scope.eq( i ).find( '.logo-palette' ).append( "<div class='palette'></div>" ).children( '.palette' ).eq( ( x * 4 ) + y );
		    	grid[ x ][ y ].css( "background-color", colors[ x ][ y ] );
		    	gsap.to( grid[ x ][ y ], { opacity: "random( 0.1, 0.5, 0.05 )", duration: "random( 1, 2, 0.25 )", repeat: -1, yoyo: true } );
		    }
	    }
    }
    
})( '.logo-palette-holder', '.logo-palette-holder.sm' );



( function( selector )
{
	'use strict'

    var scope = $( selector );
    if( !scope.length ) return;

	$( document ).ready( function()
	{
	    scope.removeClass( 'loading' );
	});

})( 'body[data-section="home"], body[data-section="webapp"]' );

/* -------------------------------------------------- */
/* -------------------------------------------------- */
/* ----- HOMEPAGE ----------------------------------- */
/* -------------------------------------------------- */
/* -------------------------------------------------- */

( function( selector )
{
	'use strict'

    var scope = $( selector );
    if( !scope.length ) return;

    window.ScrollTrigger = ScrollTrigger;

    $( window ).on( "resize", _.debounce(() =>
	{
		if( !isMobileSize() )
		{
			$( '.section-2 .video-holder-container' ).css( 'height', 'auto' );
			var padding_y = ( $( '.section-2' ).innerHeight() - $( '.section-2' ).height() ) / 2;
			if( $( '.section-2 .video-holder-container' ).height() < $( '.section-2 .header' ).height() + padding_y )
			{
				$( '.section-2 .video-holder-container' ).height( $( '.section-2 .header' ).height() + padding_y );
			}
		}
		else $( '.section-2 .video-holder-container' ).height( 'auto' );

	 	ScrollTrigger.refresh();
	}, 100 ));

	document.addEventListener( 'alpine:init', () => {
	    Alpine.data( 'modelOpen', () => ({
	        open: false,
	        image( url ) { this.$refs.image.src = url; },
	        handle( txt ) { this.$refs.handle.textContent = txt; },
	        feedback( txt ) { this.$refs.feedback.textContent = txt; },
	        toggle() { this.open = !this.open; },
			init() {
				this.$watch('open', () => {
					ScrollTrigger.normalizeScroll( { allowNestedScroll: this.open ? true: false } );
					gsap.to( "#smooth-wrapper", { filter: "blur(" + (this.open ? '10px': '0px') + ")", ease: "power2.in", duration: 0.3 });
				})
			}
	    })),
	    Alpine.data( 'menuOpen', () => ({
	        open: false,
	        toggle() { this.open = !this.open; }
	    })),
	    Alpine.data( 'modalSubmit', () => ({
	        open: false,
	        toggle() { this.open = !this.open; },
			init() {
				this.$watch( 'open', () => {
					ScrollTrigger.normalizeScroll( { allowNestedScroll: this.open ? true: false } );
				});
			}
	    })),
	    Alpine.data( 'modalVideo', () => ({
	        open: false,
	        video( url ) { this.$refs.video.src = url; },
	        toggle() { this.open = !this.open; },
			init() {
				this.$watch( 'open', () => {
					!this.open ? this.video( '' ): '';
					ScrollTrigger.normalizeScroll( { allowNestedScroll: this.open ? true: false } );
					gsap.to( "#smooth-wrapper", { filter: "blur(" + (this.open ? '10px': '0px') + ")", ease: "power2.in", duration: 0.3 });
				});
			}
	    })),
	    Alpine.data( 'modalSubmitted', () => ({
	        open: false,
	        toggle() { this.open = !this.open; }
	    })),
	    Alpine.data( 'frmCountryDropdown', () => ({
	    	allOptions: countries,
	        options: [],
	        isOpen: false,
	        openedWithKeyboard: false,
	        selectedOption: null,
			init() {
				this.options = this.allOptions;
			},
	        setSelectedOption(option) {
	            this.selectedOption = option
	            this.isOpen = false
	            this.openedWithKeyboard = false
	            this.$refs.hiddenTextField.value = option.alpha2

	            $( this.$el ).parents( '.frm-select' ).removeClass( 'error' );
	        },
	        getFilteredOptions(query) {
	            this.options = this.allOptions.filter((option) =>
	                option.country.toLowerCase().includes(query.toLowerCase()),
	            )
	            if (this.options.length === 0) {
	                this.$refs.noResultsMessage.classList.remove('hidden')
	            } else {
	                this.$refs.noResultsMessage.classList.add('hidden')
	            }
	        },
	        handleKeydownOnOptions(event) {
	            // if the user presses backspace or the alpha-numeric keys, focus on the search field
	            if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 8) {
	                this.$refs.searchField.focus()
	            }
	        },
	    })),
	    Alpine.data( 'modalContentLicense', () => ({
	        open: false,
	        toggle() { this.open = !this.open; }
	    })),
	    Alpine.data( 'modalDataUse', () => ({
	        open: false,
	        toggle() { this.open = !this.open; }
	    }));
	});

	window.modelOpen_open = function ( e ) {
		var ref = document.getElementById( 'modelOpen' )._x_dataStack[ 0 ];
			ref.open = true;
		var $tgt = $( e ).find( '.img-holder' );
		ref.image( $tgt.css( 'background-image' ).replace('url(','').replace(')','').replace(/\"/gi, "") );
		ref.handle( $tgt.data( 'handle' ) );
		ref.feedback( $tgt.data( 'feedback' ) );
	}
	window.modelOpen_close = function ( e ) { var ref = document.getElementById( 'modelOpen' )._x_dataStack[ 0 ]; ref.open = false; }

	window.modalSubmit_open  = function ( e ) { var ref = document.getElementById( 'modalSubmit' )._x_dataStack[ 0 ]; ref.open = true; }
	window.modalSubmit_close = function ( e ) { var ref = document.getElementById( 'modalSubmit' )._x_dataStack[ 0 ]; ref.open = false; }

	window.modalSubmitted_open  = function ( e ) { var ref = document.getElementById( 'modalSubmitted' )._x_dataStack[ 0 ]; ref.open = true; }
	window.modalSubmitted_close = function ( e ) { var ref = document.getElementById( 'modalSubmitted' )._x_dataStack[ 0 ]; ref.open = false; }

	window.modalVideo_open  = function ( e ) {
		var ref = document.getElementById( 'modalVideo' )._x_dataStack[ 0 ];
			ref.open = true;
		ref.video( $( e ).data( 'video' ) );
	}
	window.modalVideo_close = function ( e ) { var ref = document.getElementById( 'modalVideo' )._x_dataStack[ 0 ]; ref.open = false; }

	window.modalContentLicense_open  = function ( e ) { var ref = document.getElementById( 'modalContentLicense' )._x_dataStack[ 0 ]; ref.open = true; }
	window.modalContentLicense_close = function ( e ) { var ref = document.getElementById( 'modalContentLicense' )._x_dataStack[ 0 ]; ref.open = false; }

	window.modalDataUse_open  = function ( e ) { var ref = document.getElementById( 'modalDataUse' )._x_dataStack[ 0 ]; ref.open = true; }
	window.modalDataUse_close = function ( e ) { var ref = document.getElementById( 'modalDataUse' )._x_dataStack[ 0 ]; ref.open = false; }

	Alpine.start();

	async function submit_form_action( e )
    {
    	e.preventDefault();

    	let url = $( this ).attr( "action" );
    	let type = $( this ).attr( "method" );
    	// let formData = $( "#section-2 .form-data form" ).serialize();
    	let formData = new FormData( this );
    	let missingFields = [ { name: 'agreement', value: '' } ];
    	let num_errors = 0;

    	for( var [ key, value ] of formData.entries() )
    	{
    		if( [ '_token', 'gallery' ].indexOf( key ) >= 0 ) continue;

    		let objIndex = missingFields.findIndex( (temp) => temp[ 'name' ] === key );
    		if( objIndex >= 0 )
    		{
    			missingFields[ objIndex ].value = value;
    		}

    		switch( key )
    		{
    			case 'image':
    				var $ele = $( '.upload-img-holder' );
    					$ele[ recordedResult == undefined ? 'addClass': 'removeClass' ]( 'error' );
    					if( recordedResult == undefined ) num_errors++;
    				break;
    			case 'handle':
    				var $ele = $( '.form-data input[ name = "' + key + '" ]' ).parents( '.frm-input' );
    					$ele[ value == '' ? 'addClass': 'removeClass' ]( 'error' );
    					if( value == '' ) num_errors++;
    				break;
    			// case 'feedback':
    			// 	var $ele = $( '.form-data textarea[ name = "' + key + '" ]' ).parents( '.frm-input' );
    			// 		$ele[ value == '' ? 'addClass': 'removeClass' ]( 'error' );
    			// 		if( value == '' ) num_errors++;
    			// 	break;
    		}
		}

		for (var i = 0; i < missingFields.length; i++)
		{
    		switch( missingFields[ i ].name )
    		{
    			case 'agreement':
    				var $ele = $( '.form-data input[ name = "' + missingFields[ i ].name + '" ]' ).parents( '.frm-checkbox' );
    					$ele[ missingFields[ i ].value == '' ? 'addClass': 'removeClass' ]( 'error' );
    					if( missingFields[ i ].value == '' ) num_errors++;
    				break;
    		}
		}

		if( num_errors == 0 )
		{
			let $form = $( '#modalSubmit .form-data-holder' );
			$form.find( 'input[ name = "image" ]' ).val( recordedResult.image );

			formData = $form.serialize();

	    	$.ajax({
	    		url: url,
	    		type: type,
	    		data: formData,
	    		success: (response) => {
	    			if( response )
	    			{
	    				modalSubmit_close();
	    				modalSubmitted_open();
	    			}
	    			else
	    			{
		    			console.log( 'error',  );
		                alert( 'ERROR (' + 911 + ')\n' + 'Something went wrong.' );
	    			}
	            },
	            error: function( response ) {
	    			console.log( 'error', response.status, response.responseJSON );
	                alert( 'ERROR (' + response.status + ')\n' + response.responseJSON.message );
	            }
	        });
		}
    }

	window.addEventListener( "dragover",function( e ) { e = e || event; e.preventDefault(); }, false );
	window.addEventListener( "drop",function( e ) { e = e || event; e.preventDefault(); }, false );

	window.drawFromFile = async function( file )
	{
		var output = document.getElementById( 'preview_img' );

		output.onload = async function()
		{
			async function drawCanvas()
			{ 
				var ratio = output.naturalWidth / output.naturalHeight;
				var dWidth = 800;
				var dHeight = Math.ceil( dWidth / ratio );

			    var $canvas = $( '#modalSubmit .content-2 #preview_canvas' );
			    var canvas = $canvas.get( 0 );
			    	canvas.width = dWidth;
			    	canvas.height = dHeight;

			    var ctx = canvas.getContext( "2d" );
			    	ctx.drawImage( output, 0, 0, output.naturalWidth, output.naturalHeight, 0, 0, canvas.width, canvas.height );

				return await new Promise( resolve => setTimeout( function() {
					recordedResult = {
						image: canvas.toDataURL( 'image/jpeg' ),
						result: undefined,
					};
					
				}, 10 ) );
			}

			await drawCanvas();

		}
		output.crossOrigin = "anonymous";
		output.src = await URL.createObjectURL( file );
		// await output.decode();

		$( output ).parents( '.upload-img' ).find( '.img-instructions >div' ).addClass( 'hidden' );
	}

	window.dragOverHandler = async function( event ) { $( event.target ).parents( '.frm-input' ).find( '.upload-img' ).addClass( 'dashed' ); }
	window.dragLeaveHandler = async function( event ) { $( event.target ).parents( '.frm-input' ).find( '.upload-img' ).removeClass( 'dashed' ); }
	window.dropHandler = async function( event )
    {
    	event.preventDefault();

    	$( event.target ).parents( '.frm-input' ).find( '.upload-img' ).removeClass( 'dashed' );
		
		if( event.dataTransfer.files.length == 1 )
		{
			const file = event.dataTransfer.files[ 0 ];
			// const isImage = file.type.match( "image.*" );
			const isImage = file.type.match( /image\/png|image\/jpeg/g );

			if( isImage ) await drawFromFile( file );
			else
			{
				alert( 'Please select an image! (.png, .jpg)' );
				return;
			}
		}
		else
		{
			alert( 'Please select only 1 photo!' );
			return;
		}
	}

    window.loadFile = async function( event )
    {
        
        var input = event.target;
        var file = input.files[ 0 ];
        var type = file.type;

        await drawFromFile( file );
    };

	$( document ).ready( function( $ )
	{
		var mm = gsap.matchMedia();

		// mm.add( "(min-width: 768px)", () => {

			// create the scrollSmoother before your scrollTriggers
			let smoother = ScrollSmoother.create({
				smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
				effects: true, // looks for data-speed and data-lag attributes on elements
				// smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
	  			normalizeScroll: false
			});
		// });

		ScrollTrigger.normalizeScroll( { allowNestedScroll: false } );

		/* SETUP THE NAVIGATION MENU */
		( function( selector )
		{
			'use strict'

		    var scope = $( selector );
		    if( !scope.length ) return;

		    var $ele = $( scope ).find( '.nav-link' );
		    for (var i = 0; i < $ele.length; i++)
		    {
			    $ele.eq( i ).off( 'click' ).on( 'click', function( e ) {
			    	var $tgt = $( $( e.target ).data( 'nav' ) ).eq( 0 );
					gsap.to( window, { 
						duration: 1,
						scrollTo: $tgt.offset().top + 1,
						ease: "power2.out"
					} );
			    } );
		    }

	    	/* NAV TIMELINE */

		    var sections = $( 'section[id^="section-"]' );
		    for( var i = 0; i < sections.length; i++ )
		    {
				var t_nav = gsap.timeline({
				    scrollTrigger: {
				        trigger: $( sections.get( i ) ),
				        start: 'top center', // when the top of the trigger hits the top of the viewport
				        end: 'bottom center', // end after scrolling 500px beyond the start
				        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
				        toggleClass: { targets: $( '.menu-holder .nav-link[ data-nav="section#' + $( sections.get( i == 2 ? 1: i ) ).attr( 'id' ) + '" ]' ), className: "active" },
				        // markers: true,
				    }
				});
		    }
		    
		})( 'nav .menu-holder' );

		$( '#modalSubmit .form-data-holder' ).on( 'submit', submit_form_action );

    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */
    	/* SECTION 1 TIMELINE ------------------------------- */
    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */

		/* SETUP THE CAROUSEL */
		var splides_ele = $( '.carousel-hero .splide__list .splide__slide' );
    	for( var i = splides_ele.length - 1; i >= 0; i-- )
    	{
    		// var info = $( splides_ele[ i ] ).children( '.img-holder' ).eq( 0 ).append( "<div class='img-info'><div class='title'><div class='header'>#268ToneProud</div><div class='sub-header'>CAPTURE YOUR UNIQUE TONE</div></div><div class='footer'><div class='name'></div>&nbsp;<div class='value'></div></div></div>" ).children( '.img-info' );
    		// var info = $( splides_ele[ i ] ).children( '.img-holder' ).eq( 0 ).append( "<div class='img-info'></div><div class='img-info-text'><div class='title'><div class='header'></div><div class='sub-header'>Join me in feeling <span class='tone-proud'>#268ToneProud</span></div></div>" ).children( '.img-info' );
    		var info = $( splides_ele[ i ] ).children( '.img-holder' ).eq( 0 ).append( "<div class='img-info-wrapper'><div class='img-info'></div><div class='img-info-text'><div class='title'><div class='tone-proud'>#ToneProud</div><div class='header'></div><div class='sub-header'>Join me in embracing <br class='hidden md:block'>all of humanity’s skin tones.</div><div class='cta'><button class='btn-capture-your-tone'><span>DISCOVER YOUR TONE<span class='hidden md:inline'> &gt;</span></span></button></div></div></div>" ).find( '.img-info-wrapper' );
    		var arr = $( splides_ele[ i ] ).find( '.img-holder img' ).eq( 0 ).attr( "srcset" ).split( "," );
    		var url = arr[ 0 ].split( " " )[ 0 ];
			// var tgt = new URL( arr[ 0 ].split( " " )[ 0 ] );
    		
			info.find( ".title .header" ).html( 'I am ' + info.parent().data( 'name' ) );
			info.parent().css( "background-image", "url(" + url + ")" );
			info.parent().css( "background-position", "center" );
			info.parent().css( "background-size", "cover" );
    	}

		var splide = new Splide( '.carousel-hero', {
			type: 'loop',
			speed: 500,
			arrows: false,
			autoplay: true,
			interval: 6000,
			waitForTransition: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			start: Math.floor( Math.random() * $( '.carousel-hero .splide__slide' ).length ),
		} );

    	splide.on( 'mounted', function() {} );
    	splide.on( 'moved', function( newIndex, prevIndex, destIndex ) {
    		var $ref = $( splide.Components.Elements.slides[ newIndex ] ).find( '.img-info-text .title' );
    		gsap.to( $ref.find( '.header' ), {
				duration: 1, 
				scrambleText: {
					text: "I am " + $ref.parents( '.img-holder' ).data( 'name' ), 
					chars: "upperCase", 
					revealDelay: 0.4, 
					speed: 0.3, 
				}
			});
    		// gsap.to( $ref.find( '.sub-header' ), {
			// 	duration: 1.5, 
			// 	// delay: 0.5,
			// 	scrambleText: {
			// 		text: "Join me in feeling #268ToneProud", 
			// 		chars: "upperCase", 
			// 		revealDelay: 0.4, 
			// 		speed: 0.3, 
			// 	}
			// });
    	} );
    	splide.mount();

		$( '.section-1 .btn-capture-your-tone' ).on( 'click', function( e ) {
			gsap.to( window, { 
				duration: 1,
				scrollTo: $( '#section-5' ).offset().top + 1,
				ease: "power2.out"
			} );
		} );

		let t1_1 = gsap.timeline({
		    scrollTrigger: {
		        trigger: '.section-1',
		        start: 'top top',
		        end: 'bottom top',
		        scrub: 1,
		        markers: false,
		        onLeave: ({progress, direction, isActive}) => $( 'nav.nav-bar' ).addClass( 'bkgnd' ),
		        onEnterBack: ({progress, direction, isActive}) => $( 'nav.nav-bar' ).removeClass( 'bkgnd' )
		    }
		});

    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */
    	/* SECTION 2 TIMELINE ------------------------------- */
    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */

		var $ref = $( '.section-2 .header .content-right' );
			$ref.data( 'txt' ) == undefined ? $ref.data( 'txt', $ref.text() ): '';
		var st_2 = new SplitText( $ref, { type: "chars,words" } );

		var arr = $( '.section-2 .video-holder .img-holder img' ).eq( 0 ).attr( "srcset" ).split( "," );
		var url = arr[ 0 ].split( " " )[ 0 ];
		// var tgt = new URL( arr[ 0 ].split( " " )[ 0 ] );
		$( '.section-2 .video-holder .img-holder' ).css( "background-image", "url(" + url + ")" );
		$( '.section-2 .video-holder .img-holder' ).css( "background-position", "center" );
		$( '.section-2 .video-holder .img-holder' ).css( "background-size", "cover" );

		if( !isMobileSize() )
		{
			var padding_y = ( $( '.section-2' ).innerHeight() - $( '.section-2' ).height() ) / 2;
			if( $( '.section-2 .video-holder-container' ).height() < $( '.section-2 .header' ).height() + padding_y )
			{
				$( '.section-2 .video-holder-container' ).height( $( '.section-2 .header' ).height() + padding_y );
			}
		}
		else $( '.section-2 .video-holder-container' ).height( 'auto' );

		let mm_2 = gsap.matchMedia();
		let mm_2_breakPoint = 768;

		mm_2.add({
			// set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
			isDesktop: `(min-width: ${mm_2_breakPoint}px) and (prefers-reduced-motion: no-preference)`,
			isMobile: `(max-width: ${mm_2_breakPoint - 1}px) and (prefers-reduced-motion: no-preference)`
		}, (context) => {
			// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
			let { isDesktop, isMobile } = context.conditions;

			let t2_1 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-2 .header .content-left',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '25': '50' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});
			
			let t2_2 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-2 .header .content-right',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '25': '25' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			let t2_3 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-2 .video-holder',
			        start: ( isDesktop ? 'top': 'center-=25%' ) + ' 50%',
			        end: ( isDesktop ? 'center': 'center' ) + ' 50%',
			        // end: '+=' + ( isDesktop ? '25': '50' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			t2_1.addLabel( 't2_1-start' )
				.from( '.section-2 .header .content-left', { autoAlpha: 0, ease: "power2.out" }, 't2_1-start')
				.from( '.section-2 .header .content-left', { xPercent: -10, ease: "power1.out" }, 't2_1-start')
			  	.addLabel('t2_1-end');

			t2_2.addLabel( 't2_2-start' )
			  	.from( st_2.words, {
					// duration: 1,
					opacity: 0,
					transformOrigin: "0% 50% -50",
					translateX: "10px",
					ease: "power1.inOut",
					stagger: 0.1
			  	}, 't2_2-start' )
			  	.addLabel('t2_2-end');

			t2_3.addLabel( 't2_3-start' )
				.from( '.section-2 .video-holder .info .msg', { autoAlpha: 0, translateY: ( isDesktop ? '': '-' ) + '20px', ease: "power1.inOut", delay: ( isDesktop ? '0.0': '0.5' ) }, 't2_3-start' )
				// .from( '.section-2 .video-holder .info .title', { autoAlpha: 0, translateY: ( isDesktop ? '': '-' ) + '20px', ease: "power1.inOut", delay: ( isDesktop ? '0.25': '0.25' ) }, 't2_3-start' )
				.from( '.section-2 .video-holder .info .cta', { autoAlpha: 0, translateY: ( isDesktop ? '': '-' ) + '20px', ease: "power1.inOut", delay: ( isDesktop ? '0.5': '0.0' ) }, 't2_3-start' )
			  	.addLabel('t2_3-end');

			let t2_pin = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-2',
			        endTrigger: ".section-2 .video-holder",
			        start: 'top 0%',
			        end: 'top 0%',
			        // end: () => 'top+=' + ( $( '.section-2 .video-holder' ).height() ) + ' 0%',
			        scrub: isDesktop ? 1: false,
			        pin: isDesktop ? '.section-2-pin': false,
			        pinSpacing: false,
			        // markers: true,
			    }
			});

			return () => { 
				// optionally return a cleanup function that will be called when the media query no longer matches
			}
		});


    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */
    	/* SECTION 3 TIMELINE ------------------------------- */
    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */

		let t3 = gsap.timeline({
		    // yes, we can add it to an entire timeline!
		    scrollTrigger: {
		        trigger: '.section-3',
		        start: 'top 75%', // when the top of the trigger hits the top of the viewport
		        end: '+=50%', // end after scrolling 500px beyond the start
		        scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
		        // markers: true,
		    }
		});

		// add animations and labels to the timeline
		t3.addLabel( 't3-start' )
		  .from( '.section-3 .header .msg', { autoAlpha: 0, ease: "power2.out" }, 't3-start')
		  .from( '.section-3 .header .msg', { translateY: '-20px', scale: 0.95, ease: "power1.out" }, 't3-start')
		  .from( '.section-3 .header .title', { scale: 0.8, ease: "power2.out" }, 't3-start')
		  .addLabel('t3-end');

		var $ref = $( '.section-3 .content-left .content-left-container .info' );
			$ref.data( 'txt' ) == undefined ? $ref.data( 'txt', $ref.text() ): '';
		var st_3 = new SplitText( $ref, { type: "chars,words" } );

		let mm_3 = gsap.matchMedia();
		let mm_3_breakPoint = 768;

		mm_3.add({
			// set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
			isDesktop: `(min-width: ${mm_3_breakPoint}px) and (prefers-reduced-motion: no-preference)`,
			isMobile: `(max-width: ${mm_3_breakPoint - 1}px) and (prefers-reduced-motion: no-preference)`
		}, (context) => {
			// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
			let { isDesktop, isMobile } = context.conditions;

			let t3_1 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-3 .content-right',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '25': '25' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			let t3_2 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-3 .content-left',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '25': '25' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			let t3_3 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-3 .card .content-left',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '50': '50' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});
			
			let t3_4 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-3 .card .content-right',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '50': '50' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			t3_1.addLabel( 't3_1-start' )
			  .from( '.section-3 .content-right', { autoAlpha: 0, ease: "power2.out" }, 't3_1-start')
			  .from( '.section-3 .content-right', { xPercent: 10, ease: "power1.out" }, 't3_1-start')
			  .addLabel('t3_1-end');

			t3_2.addLabel( 't3_2-start' )
			  	.from( st_3.words, {
					// duration: 1,
					opacity: 0,
					transformOrigin: "0% 50%",
					translateX: "10px",
					ease: "power1.inOut",
					stagger: 0.1
			  	}, 't3_2-start')
			  	.addLabel('t3_2-end');

			t3_3.addLabel( 't3_3-start' )
				.from( '.section-3 .card .content-left .img-holder', { translateY: "20px", ease: "power2.out" }, 't3_3-start')
				.from( '.section-3 .card .content-left .info', { autoAlpha: 0, translateY: '20px', ease: "power1.out" })
			  	.addLabel('t3_3-end');

			t3_4.addLabel( 't3_4-start' )
				.from( '.section-3 .card .content-right .img-holder', { translateY: "20px", ease: "power2.out" }, 't3_4-start')
				.from( '.section-3 .card .content-right .info', { autoAlpha: 0, translateY: '20px', ease: "power1.out" })
			  	.addLabel('t3_4-end');

			return () => { 
				// optionally return a cleanup function that will be called when the media query no longer matches
			}
		});

		$( '.section-3 .btn-more-about-ut' ).on( 'click', function( e ) {
			gsap.to( window, { 
				duration: 1,
				scrollTo: $( '#section-4' ).offset().top + 1,
				ease: "power2.out"
			} );
		} );



    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */
    	/* SECTION 4 TIMELINE ------------------------------- */
    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */

		/* SETUP THE CAROUSEL */
		var splide_details = new Splide( '.carousel-details', {
			// type: 'loop',
			speed: 500,
			arrows: false,
			waitForTransition: true,
			perPage: 3,
			gap: '4rem',
			drag: false,
			breakpoints: {
				767: {
					perPage: 1,
					gap: '1rem',
					pagination: false,
					fixedWidth: '95%',
					padding: { left: '1.5rem', right: '1.5rem' },
					drag: true,
				},
			},
		} );

    	splide_details.on( 'mounted', function() {} );
    	splide_details.on( 'moved', function( newIndex, prevIndex, destIndex ) { } );
    	splide_details.mount();

		let mm_4 = gsap.matchMedia();
		let mm_4_breakPoint = 768;

		mm_4.add({
			// set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
			isDesktop: `(min-width: ${mm_4_breakPoint}px) and (prefers-reduced-motion: no-preference)`,
			isMobile: `(max-width: ${mm_4_breakPoint - 1}px) and (prefers-reduced-motion: no-preference)`
		}, (context) => {
			// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
			let { isDesktop, isMobile } = context.conditions;

			let t4_1 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-4 .carousel-details',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '25': '25' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			if( isDesktop )
			{
				t4_1.addLabel( 't4_1-start' )
				  .from( '.section-4 .carousel-details .content', { autoAlpha: 0, ease: "power2.out", stagger: 0.1 }, 't4_1-start')
				  .from( '.section-4 .carousel-details .content', { yPercent: 10, ease: "power1.out",stagger: 0.1 }, 't4_1-start')
				  .addLabel('t4_1-end');
			}
			else
			{
				t4_1.addLabel( 't4_1-start' )
				  .from( '.section-4 .carousel-details', { autoAlpha: 0, ease: "power2.out" }, 't4_1-start')
				  .from( '.section-4 .carousel-details', { yPercent: 10, ease: "power1.out" }, 't4_1-start')
				  .addLabel('t4_1-end');
			}


			return () => { 
				// optionally return a cleanup function that will be called when the media query no longer matches
			}
		});

    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */
    	/* SECTION 5 TIMELINE ------------------------------- */
    	/* -------------------------------------------------- */
    	/* -------------------------------------------------- */

		var $ref = $( '.section-5 .header .content-left .txt' );
			$ref.data( 'txt' ) == undefined ? $ref.data( 'txt', $ref.text() ): '';
		var st_5 = new SplitText( $ref, { type: "chars,words" } );

		let mm_5 = gsap.matchMedia();
		let mm_5_breakPoint = 768;

		mm_5.add({
			// set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
			isDesktop: `(min-width: ${mm_5_breakPoint}px) and (prefers-reduced-motion: no-preference)`,
			isMobile: `(max-width: ${mm_5_breakPoint - 1}px) and (prefers-reduced-motion: no-preference)`
		}, (context) => {
			// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
			let { isDesktop, isMobile } = context.conditions;

			let t5_1 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-5 .header .content-left',
			        start: 'top 75%',
			        end: '+=' + ( isDesktop ? '25': '25' ) + '%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			let t5_2 = gsap.timeline({
			    scrollTrigger: {
			        trigger: '.section-5 .gallery-holder',
			        start: 'top 75%',
			        end: isDesktop ? '+=25%': 'bottom 75%',
			        scrub: 1,
			        // markers: true,
			    }
			});

			t5_1.addLabel( 't5_1-start' )
			  	.from( st_5.words, {
					// duration: 1,
					opacity: 0,
					transformOrigin: "0% 50%",
					translateX: "10px",
					ease: "power1.inOut",
					stagger: 0.1
			  	}, 't5_1-start')
			  	.addLabel('t5_1-end');

			t5_2.addLabel( 't5_2-start' )
			  .from( '.section-5 .gallery' + ( isMobile ? ' .content': '' ), { autoAlpha: 0, translateY: isMobile ? 0: 20, scale: isMobile ? 0.9: 1, transformOrigin: "50% 50%", stagger: ( isMobile ? 0.1: 0 ), ease: "power2.out" })
			  .addLabel('t5_2-end');

			return () => { 
				// optionally return a cleanup function that will be called when the media query no longer matches
			}
		});

		$( '.load-more form' ).on( 'submit', function( e )
		{
			e.preventDefault();

			$( e.target ).find( 'button[ type="submit" ]' ).addClass( 'loading' );

			let tgt_page = $( e.target ).attr( 'action' );
			if( tgt_page )
			{
		    	$.ajax({
		    		url: tgt_page,
		    		type: $( e.target ).attr( 'method' ),
		    		data: $( e.target ).serialize(),
		    		success: (response) => {
		    			if( response )
		    			{
		    				let nextURL = response.next_page_url;
                            if (nextURL && nextURL.startsWith('http://')) {
                                // 如果是 http，则将其替换为 https
                                nextURL = nextURL.replace('http://', 'https://');
                            }
		    				$( e.target ).attr( 'action', nextURL );
		    				$( e.target ).find( 'button[ type="submit" ]' ).removeClass( 'loading' );
	    					$( e.target ).find( 'button[ type="submit" ]' )[ nextURL ? 'removeClass': 'addClass' ]( 'disabled' );
	    					for (var i = 0; i < response.data.length; i++) {
	    						$( '.gallery-holder .gallery' ).append( '<button class="content" onclick="modelOpen_open( this );"><div class="img-holder" data-handle="' + response.data[ i ].handle + '" data-feedback="' + response.data[ i ].feedback + '" style="background-image:url(' + response.data[ i ].image + ');"></div></button>' );
	    					}

	    					gsap.matchMediaRefresh();
		    			}
		            },
		            error: function( response ) {
		    			console.log( 'error', response.status, response.responseJSON );
		                alert( 'ERROR (' + response.status + ')\n' + response.responseJSON.message );
		            }
		        });
			}

		} );

		$( '.load-more form' ).trigger( 'submit' );


		$( window ).trigger( 'resize' );
	});

})( 'body[data-section="home"]' );





